import api from "./api";

export const getMasterDaysTime = async () => {
  return api
    .get({
      endpoint: "/master-times",
      port: process.env.REACT_APP_PORT_OPENHOUR,
    })
    .then((res) => res.data)
    .catch((err) => err.response.data);
};
